<template>
  <div
    class="report-finalized-download-buttons-area">
    <a
      v-for="report in reports"
      :key="report.file"
      class="c-btn
      report-finalized-download-buttons-area__c-btn--narrow
      report-finalized-download-buttons-area__download-btn"
      href="#"
      @click.prevent="downloadFile(report.name)">
      {{ report.title }}
    </a>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  name: 'FinalizedReportDownloadButtons',
  props: {
    payment_id: {
      type: Number,
      required: true,
      default: 0,
    },
    reports: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
    isCopyrightReport: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      error: '',
    }
  },
  methods: {
    isPdf(fileName) {
      return fileName.match(/\.pdf$/)
    },
    async downloadFile(fileName, openInBrowser = false) {
      try {
        let response = {}
        if (this.isCopyrightReport) {
          response = await window.axios.get(`/api/client/reports/finalized/download/${this.$store.state.auth.company.id}`, {
            params: {
              payment_id: this.reports && this.reports.length > 0 ? this.reports[0].payment_id : 0,
              file_name: fileName,
              type: 'copyright',
            },
            responseType: 'blob',
          })
        } else {
          response = await window.axios.get(`/api/client/reports/finalized/download/${this.$store.state.auth.company.id}`, {
            params: {
              payment_id: this.payment_id,
              file_name: fileName,
              type: 'distribution',
            },
            responseType: 'blob',
          })
        }
        const blob = new Blob([response.data], {
          type: response.data.type,
        })
        // ブラウザで開く
        if (openInBrowser) {
          const fileURL = window.URL.createObjectURL(blob)
          const anchor = document.createElement('a')
          anchor.href = fileURL
          anchor.target = '_blank'
          anchor.click()
        } else {
          const fileSuffix = this.$store.state.auth.company.name
          if (this.isCopyrightReport) {
            saveAs(blob, fileName)
          } else {
            saveAs(blob, `【${fileSuffix}】${fileName}`)
          }
        }
      } catch (e) {
        this.error = e.message
      }
    },
  },
}
</script>

<style scoped>
.open-in-browser-link:hover img {
  opacity: 0.5;
}
</style>
